import React, { useEffect, useState } from "react";
import { Polyline, Tooltip } from "react-leaflet";
import { fetchDownstreamPaths } from "../../lib/api";

const RISK_COLOR = { elevated: "#E63946", advisory: "#F59E0B", none: "#4A9BD1" };

export default function DownstreamLayer() {
  const [paths, setPaths] = useState([]);

  useEffect(() => {
    const load = () =>
      fetchDownstreamPaths().then((d) => setPaths(d.paths || [])).catch(() => {});
    load();
    const t = setInterval(load, 10 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <>
      {paths.map((p) => {
        const color = RISK_COLOR[p.risk_level] || RISK_COLOR.none;
        const risky = p.risk_level !== "none";
        return (
          <Polyline
            key={`ds-${p.scar_id}`}
            positions={p.coords}
            pathOptions={{
              color,
              weight: risky ? 4 : 2.5,
              opacity: risky ? 0.9 : 0.55,
              dashArray: "2 7",
              lineCap: "round",
            }}
          >
            <Tooltip sticky>
              <div style={{ fontSize: 12 }}>
                <b>Drainage below {p.name} burn scar</b>
                <br />
                {risky
                  ? `${p.risk_level === "elevated" ? "ELEVATED" : "ADVISORY"} debris-flow risk — mudflows follow this creek path`
                  : "Downstream path — where scar runoff and debris would travel"}
              </div>
            </Tooltip>
          </Polyline>
        );
      })}
    </>
  );
}
